module.exports = __webpack_public_path__ + "img/money.0e1e6d4.svg";